import { z } from "zod";

import { WidgetConfigSchema, WidgetTypeList } from "../schemas/widgets";

export const WidgetDtoSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  enabledSitewide: z.boolean().optional().default(false),
  parentId: z.string().uuid().nullish(),
  widgetType: z.enum(WidgetTypeList),
  config: WidgetConfigSchema,
});

export type WidgetDto = z.infer<typeof WidgetDtoSchema>;
